import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BrowserService {
  public isSafari(): boolean {
    const ua = navigator.userAgent.toLowerCase();
    const vendor = navigator.vendor.toLowerCase();

    // Check for Safari in userAgent and Apple vendor
    const isSafari = ua.includes('safari') && vendor.includes('apple');

    // Exclude browsers that include Safari in their userAgent
    const isOtherBrowser =
      ua.includes('chrome') ||
      ua.includes('crios') ||
      ua.includes('edg') ||
      ua.includes('firefox') ||
      ua.includes('fxios') ||
      ua.includes('opera') ||
      ua.includes('opr') ||
      ua.includes('vivaldi');

    return isSafari && !isOtherBrowser;
  }

  public checkMovSupport(): boolean {
    return this.isSafari() || this.isFirefox();
  }

  public isFirefox(): boolean {
    return navigator.userAgent.toLowerCase().includes('firefox');
  }

  public isIOS(): boolean {
    // 1. Prefer the modern API if it exists
    if (navigator['userAgentData'] && navigator['userAgentData'].platform) {
      return navigator['userAgentData'].platform === 'iOS';
    }

    // 2. Classic UA tokens (covers iPhone/iPod + older iPads)
    const ua = navigator.userAgent;
    if (/iphone|ipod|ipad/i.test(ua)) {
      return true;
    }

    // 3. Detect iPadOS ≥13 (pretends to be a Mac but has a touch screen)
    return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  }
  /**
   * Detects if the current browser is running on a mobile device.
   */
  public isMobileBrowser(): boolean {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera || '';
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i;
    return mobileRegex.test(userAgent);
  }

  public getBrowserName(): 'safari' | 'firefox' | 'chromium' {
    if (this.isSafari()) {
      return 'safari';
    }
    if (this.isFirefox()) {
      return 'firefox';
    }
    return 'chromium';
  }
}
